import RoutesMap from './RoutesMap';

export default RoutesMap;
